/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BuilderNavigationService } from '@gh/builder-shared';
import {
  GoogleDocument,
  InputFileComponent,
  textMessageDialogRoute,
} from '@gh/common-internal-shared';
import { getRouteInitData } from '@gh/common-shared';
import {
  DialogService,
  NotificationService,
  STYLES_FLEX_COLUMN_LAYOUT,
  TextMessageDialogConfig,
  WaitingService,
} from '@gh/core-ui';
import { createLink, openInNewWindow } from '@gh/core-util';

import { replace } from 'lodash';
import { ImportLeadsTabBusinessService } from '../../resources/import-leads-tab-business.service';

import { ImportLeadsTemplate } from '../../resources/import-leads-tab.model';
import { TranslationService } from '@gh/core-mls';

@Component({
  standalone: false,
  selector: 'gh-import-leads-tab',
  templateUrl: 'import-leads-tab.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
})
export class ImportLeadsTabComponent implements OnInit {
  leadsExcelTemplate: ImportLeadsTemplate;
  googleSheet: Maybe<GoogleDocument>;

  isHistorical: boolean = false;

  @ViewChild(InputFileComponent, { static: true }) inputFileComponent: InputFileComponent;

  constructor(private waitingService: WaitingService,
              private route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              private notificationService: NotificationService,
              private businessService: ImportLeadsTabBusinessService,
              private dialogService: DialogService,
              public translationService: TranslationService) {
  }

  get isImportLeadsExcelFileSelected(): boolean {
    return this.inputFileComponent.isFileSelected;
  }

  get isImportLeadsGoogleSheetFileSelected(): boolean {
    return Boolean(this.googleSheet);
  }

  ngOnInit(): void {
    const { leadsExcelTemplate } = getRouteInitData(this.route);
    this.leadsExcelTemplate = leadsExcelTemplate;
  }

  onImportExcel(): void {
    if (this.inputFileComponent.file) {
      this.businessService.getBatchId(this.inputFileComponent.file, this.isHistorical).pipe(
        (this.waitingService.operator()))
        .subscribe(() => {
          this.notificationService.success('msg_import_leads_tasks_added');
          this.inputFileComponent.clear();
          this.isHistorical = false;
        },         this.notificationService.processAll);
    }
  }

  onImportGoogleSheet(): void {
    if (this.googleSheet) {
      this.businessService.getGoogleBatchId(this.googleSheet, this.isHistorical).pipe(
        (this.waitingService.operator()))
        .subscribe(() => {
          this.notificationService.success('msg_import_leads_tasks_added');
          this.googleSheet = void 0;
          this.isHistorical = false;
        },         this.notificationService.processAll);
    }
  }

  onSelectGoogleSheet(files?: GoogleDocument[]): void {
    if (files) {
      this.googleSheet = files[0];
    }
  }

  onTemplateDownload(type?: string): void {
    if (type) {
      openInNewWindow(replace(this.leadsExcelTemplate.templateUrl, /\+/g, ' '));
    } else {
      this.businessService.getGoogleSheetTemplate()
        .pipe(this.waitingService.operator())
        .subscribe(
          (template) =>
            this.dialogService.openWithInput(textMessageDialogRoute, <TextMessageDialogConfig<string>>{
              title: this.translationService.get('lbl_link_to_google_sheet'),
              html: `${this.translationService.get('lbl_link_to_generated_doc')}:\n${createLink(template.templateUrl)}`,
              buttons: [{ value: 'ok', title: this.translationService.get('lbl_ok'), type: 'primary' }],
            }),
          this.notificationService.processAll);
    }
  }
}
